<template>
  <div
    v-if="isLoading"
  >
    <div class="loader" />
  </div>
  <div
    v-else
    class="member_edit_group">
    <div class="clinic_name_area">
      <h3>その他グループメンバー</h3>
    </div>
    <div class="tab_wrap">
      <input
        id="tab1"
        type="radio"
        name="tab_btn"
        checked
      >
      <input
        id="tab2"
        type="radio"
        name="tab_btn"
      >
      <input
        id="tab3"
        type="radio"
        name="tab_btn"
      >
      <div class="tab_area">
        <label
          class="tab1_label"
          for="tab1"
        >歯科医師</label>
        <label
          class="tab2_label"
          for="tab2"
        >歯科衛生士</label>
        <label
          class="tab3_label"
          for="tab3"
        >助手・受付</label>
      </div>
      <div class="panel_area">
        <div
          id="panel1"
          class="staff_list_area tab_panel"
        >
          <ul>
            <li
              v-if="dentistMembers.length <= 0"
              class="list_empty"
            >メンバーがいません</li>
            <organization-member
              v-for="member in dentistMembers"
              :key="member.user_id"
              :organization="organization"
              :member="member"
              mode="add"
              @add="addClinicUser"
            />
          </ul>
        </div>
        <div
          id="panel2"
          class="staff_list_area tab_panel"
        >
          <ul>
            <li
              v-if="dentalHygienistMembers.length <= 0"
              class="list_empty"
            >メンバーがいません</li>
            <organization-member
              v-for="member in dentalHygienistMembers"
              :key="member.user_id"
              :organization="organization"
              :member="member"
              mode="add"
              @add="addClinicUser"
            />
          </ul>
        </div>
        <div
          id="panel3"
          class="staff_list_area tab_panel"
        >
          <ul>
            <li
              v-if="dentalAssistantMembers.length <= 0"
              class="list_empty"
            >メンバーがいません</li>
            <organization-member
              v-for="member in dentalAssistantMembers"
              :key="member.user_id"
              :organization="organization"
              :member="member"
              mode="add"
              @add="addClinicUser"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import OrganizationMember from "./organization_member.vue"
  import OrganizationApi from '../../../api/organizations.js'
  import ClinicApi from '../../../api/clinics.js'

  export default {
    components: {
      OrganizationMember
    },
    props: {
      organization: {
        type: Object,
        requires: true,
        default: null
      },
      addToClinic: {
        type: Object,
        requires: true,
        default: null
      },
      clinicUsers: {
        type: Array,
        requires: true,
        default: () => []
      }
    },
    data () {
      return {
        organizationMembers: [],
        isLoading: false,
        isLocking: false
      }
    },
    computed: {
      organizationId: vm => vm.organization && vm.organization.id,
      dentistMembers: vm => vm.organizationMembers && vm.filteredMember('dentist'),
      dentalHygienistMembers: vm => vm.organizationMembers && vm.filteredMember('dental_hygienist'),
      dentalAssistantMembers: vm => vm.organizationMembers && vm.filteredMember('dental_assistant'),
      exceptUserId: vm => vm.clinicUsers && vm.clinicUsers.map(u => u.user_id)
    },
    created () {
      this.loadUsers()
    },
    methods: {
      loadUsers() {
        this.isLoading = true
        OrganizationApi.getOrganizationMembers(this.organization.id).then((res) => {
          this.organizationMembers = res.data.organization_members
        }).finally(() => {
          this.isLoading = false
        })
      },
      filteredMember(license) {
        // ターゲットのclinicメンバーでなく、ある職種のユーザを抽出
        return this.organizationMembers
          .filter((m) => !this.exceptUserId.includes(m.user_id))
          .filter((m) => m.user.license === license )
      },
      addClinicUser(member) {
        if(this.isLocking === true) return
        this.isLocking = true
        ClinicApi.addClinicUser(this.addToClinic.id, { user_id: member.user_id, role: 'staff' }).then(() => {
          OrganizationApi.getOrganizationMember(member.id).then((res) => {
            this.$emit('add', res.data.organization_member)
          }).finally(() => {
            this.isLocking = false
          })
        }).catch(() => {
          this.isLocking = false
        })
      }
    }
  }
</script>
<style scoped>
.loader {
  font-size: 50px;
}
</style>
